import accolades_slider from './components/accolades-slider.js';
import accordion from './components/accordion.js';
import announcement_bar from './components/announcement-bar.js';
import flexible_accordion from './components/flexible-accordion.js';
import gallery_slider from './components/gallery-slider.js';
import general from './components/general.js';
import logo_animation from './components/logo-animation.js';
import panels from './components/panels.js';
import playbtn from './components/playbtn.js';
import tabs from './components/tabs.js';
import team_roster from './components/team-roster.js';
import three_col_slider from './components/three-col-slider.js';
import timeline_slider from './components/timeline-slider.js';
import video from './components/video.js';
import careers from './components/flexible-careers.js';

// Libraries
import $ from 'jquery';

class App {
	constructor(page, initialized) {
		this.page = page;
		this.initialized = initialized;

		if (this.initialized == false) {
			if (document.readyState === 'loading') {
				document.addEventListener('DOMContentLoaded', this.init());
			} else {
				this.init();
			}
		}
	}

	init() {
		this.initialized = true;

		accolades_slider();
		accordion();
		announcement_bar();
		careers();
		flexible_accordion();
		gallery_slider();
		general();
		logo_animation();
		panels();
		playbtn();
		tabs();
		team_roster();
		three_col_slider();
		timeline_slider();
		video();
	}
}

new App(document.querySelector('body'), false);
